import { PropsWithChildren } from "react";
import { ToastProvider } from "@commonlibs";
import QueryClientProvider from "./query/QueryClientProvider";
import { ConfigProvider } from "./config";
import ErrorHandler from "./common/components/feedback/ErrorHandler/ErrorHandler";
import AwsRumProvider from "./config/awsRumProvider/AwsRumProvider";

const Providers = ({ children }: PropsWithChildren<unknown>): JSX.Element => (
    <AwsRumProvider>
        <ConfigProvider>
            <ToastProvider>
                <ErrorHandler>
                    <QueryClientProvider>{children}</QueryClientProvider>
                </ErrorHandler>
            </ToastProvider>
        </ConfigProvider>
    </AwsRumProvider>
);

export default Providers;
